import React, { useCallback } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Login from './screens/Login';
import Register from './screens/Register';
import Home from './screens/Home';
import Scan from './screens/Scan';
import Compare from './screens/Compare';
import Basket from './screens/Basket';
import Insights from './screens/Insights';
import Settings from './screens/Settings';
import LiveSearch from './screens/LiveSearch';

/**
 * The screens were designed as self-contained mobile views and still contain
 * plain <a href="/route"> links. This capture handler turns those into
 * client-side navigations so we keep a single-page app without having to
 * rewrite every link inside the screens.
 */
function useAnchorRouting() {
  const navigate = useNavigate();
  return useCallback(
    (event) => {
      const anchor = event.target.closest && event.target.closest('a[href^="/"]');
      if (!anchor) return;
      if (anchor.target === '_blank' || event.metaKey || event.ctrlKey || event.shiftKey) return;
      event.preventDefault();
      navigate(anchor.getAttribute('href'));
    },
    [navigate]
  );
}

export default function App() {
  const onClickCapture = useAnchorRouting();

  return (
    <div
      onClickCapture={onClickCapture}
      style={{
        minHeight: '100dvh',
        display: 'flex',
        justifyContent: 'center',
        background: '#0D1B2A',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 480,
          minHeight: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          overflow: 'hidden',
          background: '#F4F6FB',
        }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/scan" element={<Scan />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/basket" element={<Basket />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/live-search" element={<LiveSearch />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
}
